import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SessionList from '../components/sessions/SessionList';
import SessionFilters from '../components/sessions/SessionFilters';

export interface SessionFilterState {
  dateRange: string;
  device: string;
  hasErrors: boolean;
  hasRageClicks: boolean;
  url: string;
  /** raw value typed into the identity search box — email, phone, or customer UUID */
  identityQuery: string;
}

export default function SessionsPage() {
  const [searchParams] = useSearchParams();
  // Restore page from URL param (preserves position when returning from replay)
  const initialPage = parseInt(searchParams.get('page') || '1', 10);
  const [page, setPage] = useState(initialPage);
  const [filters, setFilters] = useState<SessionFilterState>({
    dateRange: '7d',
    device: 'all',
    hasErrors: false,
    hasRageClicks: false,
    url: '',
    identityQuery: '',
  });

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Sessions</h1>

      <div className="flex gap-6">
        <SessionFilters filters={filters} onChange={setFilters} />
        <div className="flex-1">
          <SessionList filters={filters} page={page} onPageChange={setPage} />
        </div>
      </div>
    </div>
  );
}
